import apiCall from 'apps/investment/apiCalls/stock-balance-histories';
import {
  buildColumns,
  filterConfig,
} from 'apps/investment/components/stock-balance-histories/config';
import ItemDetail from 'apps/investment/components/stock-balance-histories/detail';
import { DynamicFilterForm } from 'common/dynamic-filter-form';
import { DetailPage, ListPage } from 'common/ui/admin-CRUD/page';

const LIST_URL = '/admin/stock-balance-histories';

// Monitoring view of every user's deposit/withdrawal requests. Read-only:
// no create, edit or actions. Per-user history lives on the stock account.
export const AdminBalanceHistoryListPage = () => (
  <ListPage
    title="Balance History"
    description="All Withdrawal/Deposit Requests"
    apiCall={apiCall}
    columnsGenerator={() => buildColumns(LIST_URL)}
    FilterForm={() => (
      <DynamicFilterForm fields={filterConfig} showSearchField={false} />
    )}
  />
);

export const AdminBalanceHistoryDetailPage = () => (
  <DetailPage
    title="Request"
    apiCall={apiCall}
    listUrl={LIST_URL}
    ItemDetail={ItemDetail}
    options={{ editEnabled: false }}
  />
);
